import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CompareFilter from './CompareFilter/CompareFilter';
import {
  ClearAction,
  ClearButton,
  CompareSortFilterCont,
  FilterDropCont,
} from './CompareSortFilter.styles';
import { ICompareSortType } from '../../constans/compare';
import { useGroupComparison } from '../../hooks';
import { useCompareTeamsSearch } from '../../hooks/useCompareTeamsSearch';
import { useFilters } from '../../hooks/useFilters';
import SearchDropdown from '../SearchDropdown/SearchDropdown';
import CloseMark from '@/assets/icons/closeMark.svg?react';

export interface IFilterMultiselectDataEl {
  id: string;
  name: string;
}
const CompareSortFilter: FC = () => {
  const { t } = useTranslation();
  const { sortTypesArr } = useGroupComparison();
  const [currentSortType, setCurrentSortType] = useState<ICompareSortType | undefined>(
    sortTypesArr[0]
  );
  const { currentFilters } = useFilters();
  const {
    sortTeamList,
    clearSortAndFilters,
    teamsList,
    searchForTeam,
    manageTeamSelection,
    manageRiskSelection,
    teamFiltersSelected,
    riskFiltersSelected,
    applyTeamListFilters,
    selectedItemsCount,
    clearFilters,
    catsNames,
    riskPresent,
  } = useCompareTeamsSearch();
  const sortItems = [...sortTypesArr, ...catsNames];
  const sortFiltersPresent = currentFilters?.compareSort;
  const isSortingAsc = String(sortFiltersPresent).search('asc');
  const isSortingDesc = String(sortFiltersPresent).search('desc');
  const sortingState = useMemo(() => {
    if (isSortingAsc !== -1) {
      return 'asc';
    }
    if (isSortingDesc !== -1) {
      return 'desc';
    }
    return 'asc';
  }, [isSortingAsc, isSortingDesc]);

  const clearAll = () => {
    setCurrentSortType(sortTypesArr[0]);
    return clearSortAndFilters();
  };

  const clearSort = () => {
    setCurrentSortType(sortTypesArr[0]);
    return clearFilters('compareSort');
  };

  const changeSortMode = (sortType: ICompareSortType) => {
    setCurrentSortType(sortType);
    sortTeamList(sortType?.value, 'asc');
  };
  const teamFiltersPresent = currentFilters?.compare;
  const disabledClearCondition = !sortFiltersPresent && !teamFiltersPresent;

  useEffect(() => {
    if (typeof sortFiltersPresent === 'string') {
      const filterObj = JSON.parse(sortFiltersPresent);
      const filterObjArr = Object.keys(filterObj);
      const sortFilterVal = filterObjArr.length > 0 ? filterObjArr[0] : {};
      if (catsNames.length > 0) {
        const initialValue = sortItems.find((item: ICompareSortType) => {
          return item.value === sortFilterVal;
        });
        setCurrentSortType(initialValue);
      }
    }
  }, [catsNames]);
  return (
    <CompareSortFilterCont>
      <FilterDropCont>
        <CompareFilter
          clearFilters={clearFilters}
          selectedItemsCount={selectedItemsCount}
          searchForTeam={searchForTeam}
          teamsList={teamsList ?? []}
          manageTeamSelection={manageTeamSelection}
          teamFiltersSelected={teamFiltersSelected}
          manageRiskSelection={manageRiskSelection}
          riskFiltersSelected={riskFiltersSelected}
          applyTeamListFilters={applyTeamListFilters}
          highlighted={!!teamFiltersPresent}
          noRisk={!riskPresent}
        />
      </FilterDropCont>
      <FilterDropCont>
        <ClearAction data-testid="clearSort" onClick={clearSort}>
          {t('report.groupComparison.reset')}
        </ClearAction>
        <SearchDropdown
          width="320px"
          items={sortItems}
          placeholder={t('report.groupComparison.sortBy')}
          selectEl={el => changeSortMode(el as ICompareSortType)}
          label={t('report.groupComparison.sortBy')}
          activeEl={currentSortType}
          selectFullObject
          sortMethod={(state: string) => sortTeamList(currentSortType?.value, state)}
          highlighted
          sortingState={sortingState}
        />
      </FilterDropCont>
      <ClearButton data-testid="ClearAll" disabled={disabledClearCondition} onClick={clearAll}>
        <CloseMark />
        {t('report.groupComparison.clearAll')}
      </ClearButton>
    </CompareSortFilterCont>
  );
};

export default CompareSortFilter;
